export const environment = {
  production: true,
  name: "prod",
  gtmId: 'G-KLZHM4F5RV',
  useHash: true,
  serverUrl: "https://api.gigsumo.com/",
  ssrUrl: "https://www.gigsumo.com/",
  careOnlineWebUrl: "https://app.gigsumo.com/#/",
  directoryUrl: "http://careonline-directory.s3-website-us-east-1.amazonaws.com/#/",
  webSocketUrl: "https://server-prod-lb.gigsumo.com:8090/gigsumo-social/ws",
  webSocketUrlStream: "https://stream-prod-lb.gigsumo.com:8090/gigsumo-social/ws",
  LAMDA_URL_temp_contactus: "https://api.gigsumo.com/contactus",
  LAMDA_URL: "https://njwxccoe70.execute-api.us-east-1.amazonaws.com/PROD/subscription/",
  AsyncSync: "SYNC",
  googleRedirectUri:"https://accounts.google.com/o/oauth2/auth?client_id=272100625117-v8fveqq47vuksdksqqhk20pn03t2dp02.apps.googleusercontent.com&response_type=code&redirect_uri=https://api.gigsumo.com/user/findOpenAuthentication&scope=openid email profile"
};
